/* eslint-disable react/no-danger */
import { Stack, useTheme } from '@mui/material';

import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Iconify from '@/app/components/iconify';

export default function FaqAccordions() {
  const theme = useTheme();
  const items = [
    {
      title: 'Does XCIPTV Smart Player contain any contents? Where can I get a good playlist?',
      content: `XCIPTV Smart Player and any administrator does not help you to find a good playlist.<br>Also we don't provide any kind of playlists. We are not responsible for the content uploaded to our APP.
<br>Please don't buy the app when you don't have any playlist or Media for the APP, because no contents are included after the activation.<br>
<br>You payment will not be refunded if you buy it without having any list or something is not workng.`,
    },
    {
      title: 'Why is the app freezing on start?',
      content: `You should experience the issue at the first time running after installation, because the app should be downloading resources from the server`,
    },
    {
      title: 'Why is the app not working when the PLAYLIST worked on my computer?',
      content: `This can caused because of the ISP lock, if your computer is in a different Network. But when the network is same as your computer and it is not working it can be caused because of your TV's supported format.<br><br>Not every Smart-TV support all contents. Every TV model are totally different or may not support specific stream formats!
<br><br>Below you can see the supported formarts from Smart TV's:
&nbsp;&nbsp;&bull;&nbsp;Samsung supported formats and codecs<br/>
&nbsp;&nbsp;&bull;&nbsp;LG webOS supported formats and codecs<br/>
&nbsp;&nbsp;&bull;&nbsp;Android platform supported formats and codecs`,
    },
    {
      title: `Why can't I start the APP?`,
      content: `This is maybe because of your internet connection, please check at first your internet connection befor you contact your provider. Many times it is caused because of the connection and not because of the provider!`,
    },
    {
      title: 'Does the XCIPTV Smart Player APP have an EPG-SYSTEM?',
      content: `No, the app didn't have an EPG system integrated but if your provider has an EPG - READY system then it would work with our platform.`,
    },
  ];
  return (
    <Stack gap={0}>
      {items.map((item, index) => (
        <Accordion key={index} sx={{ border: 'none' }}>
          <AccordionSummary
            expandIcon={<Iconify icon="ic:baseline-expand-more" />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontWeight: 'bold' }}
          >
            {item.title}
          </AccordionSummary>
          <AccordionDetails sx={{ color: theme.palette.text.secondary }}>
            <div dangerouslySetInnerHTML={{ __html: item.content }} />
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
}
